import React from "react";
import api from "~/services/api";
import { Label, Input, Select } from "~/componentes/CustomForm";

import { Container } from "./styles";
import CustomScrollBar from "~/componentes/CustomScrollBar";
import { Materialize } from "~/styles/materializeGrid";
import { SLModalFooter } from "~/pages/Sistema/componentes/SistemaList";
import ShowConfirmacao from "~/utils/ShowConfirmacao";

function CreateContent({ estados }) {
  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let response;

        response = await api.post("/signed/empresa/administracao/organizacao/unidade", {
          ...data,
        });

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao cadastrar essa Unidade, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja cadastrar essa Unidade?`,
        successModal: `Unidade cadastrada com sucesso!`,
      }
    );
  }

  return (
    <Container onSubmit={handleSubmit}>
      <CustomScrollBar fixScrollMargin autoHeightMin="62vh" autoHeightMax="62vh">
        <Materialize className="padding-form">
          <div className="row">
            <Label title="Nome *" className="col s8 m8 l8">
              <Input name="nome" />
            </Label>
            <Label title="Estado *" className="col s4 m4 l4">
              <Select
                isNumber
                list={{ list: estados, value: "id", label: "nome" }}
                name="idEstado"
                firstOption
              />
            </Label>
          </div>
        </Materialize>
      </CustomScrollBar>
      <SLModalFooter />
    </Container>
  );
}

export default CreateContent;
